'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _competitors = require('./directives/competitors/competitors.dir');

var _writeEmail = require('./directives/write-email/write-email.dir');

var _searchBar = require('./directives/search-bar/search-bar.dir');

var _enter = require('./directives/f-enter/enter.dir');

var _selectOnclick = require('./directives/select-onclick/select-onclick');

var _msg = require('./services/messages/msg.service');

var _dateToTZ = require('./filters/dateToTZ');

exports.default = angular.module('ifeis.common', ['ifeis.new-dependent', 'ifeis.new-school']).directive(_competitors.CompetitorsDirective.selector, function () {
  return _competitors.CompetitorsDirective;
}).directive(_writeEmail.WriteEmailDirective.selector, function () {
  return _writeEmail.WriteEmailDirective;
}).directive(_searchBar.SearchBarDirective.selector, function () {
  return _searchBar.SearchBarDirective;
}).directive('fEnter', function () {
  return new _enter.EnterDirective();
}).directive('selectOnClick', _selectOnclick.selectOnClick.create).service('msgService', _msg.MsgService).filter('dateToTZ', _dateToTZ.dateToTZ);


//////////////////
// WEBPACK FOOTER
// ./common/common.module.js
// module id = 55
// module chunks = 0